export default __webpack_public_path__ + "static/media/arrow-dir.d76c05cc.gif";